import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function AffiliateDisclosurePage(): React.JSX.Element {
  return (
    <ComplianceDocument
      slug="affiliate-disclosure"
      title="Affiliate Disclosure"
      description={
        <span>
          Some products we recommend include links to shops where you can buy them. A few of
          those links may earn <strong>kivo.skin</strong> a small commission — at no extra cost to
          you, and it never changes which products we show you.
        </span>
      }
    />
  );
}
